module.exports = __webpack_public_path__ + "static/media/qygn.f845180a.jpg";